<template>
  <div id="app">
    <keep-alive>
      <router-view :key="appKey" v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view :key="appKey"  v-if="!$route.meta.keepAlive"/>
  </div>
</template>
<script>
export default {
  data() {
    return {
      appKey: 1
    }
  },
  watch:{
    '$route':function(newValue,oldValue) {
      this.appKey = new Date().getTime()
    }
  },
}
</script>

<style lang="scss">
@import url("common/YouSheBiaoTiHei/font.css");
#app {
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  font-family: 'SourceHanSerifCN-Regular';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  font-size: 14px;
  // filter:progid:DXImageTransform.Microsoft.BasicImage(graysale=1);
  // -webkit-filter: grayscale(100%);
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  display: block;
  background-color: #e4e4e4;
}
::-webkit-scrollbar-thumb {
  width: 6px;
  height: 6px;
  display: block;
  border-radius: 10px;
  background-color: #C1C1C1;
  background-image: -webkit-linear-gradient(
          45deg,
          hsla(0, 0%, 100%, 0.2) 25%,
          transparent 0,
          transparent 50%,
          hsla(0, 0%, 100%, 0.2) 0,
          hsla(0, 0%, 100%, 0.2) 75%,
          transparent 0,
          transparent
  );
}
html::-webkit-scrollbar {
  display: none;
}
html::-webkit-scrollbar-thumb {
  display: none;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #00AA86;//#42b983;
    }
  }
}

::v-deep .el-popover__title {
    margin-bottom: 10px !important;
    padding-bottom: 10px !important;
    border-bottom: 1px solid #DCDFE6 !important;
  }


.dialogbox {
  border-radius: 12px !important;
  .el-dialog{
    border-radius: 12px;
  }
  .el-dialog__header {
    padding: 0;
    line-height: normal;
    padding-top: 15px;
    border-bottom: 1px solid #e2e2e2;
    .top_box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      padding-bottom: 15px;
      .add_cla_tit {
        font-size: 16px;
        font-weight: 600;
        color: #000000;
        font-family: 'SourceHanSerifCN-Heavy';
      }
      .add_cla_pic {
        background: url("./assets/img/cls.png");
        display: inline-block;
        width: 25px;
        height: 24px;
        background-size: 100% 100%;
        cursor: pointer;
      }
    }
  }
  .el-dialog__body {
    padding: 15px 20px;
    line-height: normal;
    margin: 0;

    .center_box_sub_add {
      .tips {
        text-align: left;
        margin: 0 24px 12px 24px;
        background: rgba(255, 125, 72, 0.10);
        border-radius: 4px;
        height: 26px;
        line-height: 27px;
        padding-left: 5px;
        color: #FF7D48;
        font-size: 13px;
        .el-icon-warning {
          margin-right: 5px;
        }
      }
      .downloadcon {
        margin: 0 24px 12px 24px;
        background: #F8F9FA;
        padding: 24px;
        text-align: left;

        .con-title {
          color: #2E3238;
          margin-bottom: 12px;
        }
        .con-content {
          color: #8D939A;

          .greenspan {
            color: #00AA86;
            cursor: pointer;
          }
        }
      }
      .uploadcon {
        margin: 0 24px;
        background: #F8F9FA;
        padding: 24px;
        text-align: left;

        .con-title {
          color: #2E3238;
          margin-bottom: 12px;
        }
        .el-upload {
          width: 100%;

          .el-upload-dragger {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            .el-icon-circle-plus-outline {
              background: url(./assets/img/upload_file_icon.png) no-repeat;
              background-size: 100% 100%;
              width: 39px;
              height: 39px;
            }
            .el-icon-circle-plus-outline::before{
              content: '';
            }
          }
        }
      }

      .classlist {
        display: flex;
        flex-wrap: wrap;
        .class-item {
          width: 90px;
          height: 36px;
          line-height: 36px;
          border: 1px solid #DDDDDD;
          border-radius: 5px;
          margin-right: 5px;
          margin-bottom: 5px;
        }
      }
    }
    .tsdialogcon {
      .tipstxt {
        color: #333;
      }
    }
    .examnumeditcon {
      .editcon {
        display: flex;
        align-items: center;
      }
    }
    .tssetdialog {
      .el-checkbox {
        margin-bottom: 10px;
        float: right;
      }
      .el-table {
        margin-bottom: 10px;
      }
      .tips {
        background: #FFF8EA;
        color: #FDBF3F;
        text-align: center;
        height: 30px;
        line-height: 30px;
        width: 100%;
        margin: 0;
      }
      .el-table th,
      .el-table tr {
        background-color: #F8F9FA;
      }
      .el-table td,
      .el-table th {
        padding: 5px 0;
      }
      .el-table thead {
        .cell {
          line-height: 18px;
        }
      }
      .way-item {
        margin-bottom: 10px;
        display: flex;
        align-items: center;
      }
    }
    .stuinfos {
      .btnscon {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-bottom: 10px;
        .btn-item {
          color: #00AA86;
          border-radius: 4px;
          padding: 0 15px;
          height: 32px;

          span {
            display: flex;
            align-items: center;
          }

          .el-icon-yrjc {
            background: url('./assets/img/import_icon.png') no-repeat;
            background-size: 100%;
            width: 14px;
            height: 14px;
          }
          .el-icon-gxjc {
            background: url('./assets/img/renew_icon.png') no-repeat;
            background-size: 100%;
            width: 14px;
            height: 14px;
          }
          .el-icon-sc {
            background: url('./assets/img/del_icon.png') no-repeat;
            background-size: 100%;
            width: 14px;
            height: 14px;
          }
        }
        .delbtn-item {
          border-color: #FF6B6B;
          color: #FF6B6B;
        }
      }
      .tablecon {
        border: 1px solid #e2e2e2;
      }
      .paginationcon {
        text-align: right;
        margin-top: 10px;
      }
      .querycon {
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        .gradeitem {
          border: 1px solid #DCDFE6;
          border-radius: 4px;
          display: flex;
          align-items: center;
          box-sizing: border-box;
          height: 32px;
          padding-left: 10px;
          width: fit-content;
          

          .title {
            font-size: 14px;
            color: #767676;
          }
          .el-radio-group {
            line-height: unset;
          }
          .el-radio {
            margin-right: 15px;
            line-height: unset;
          }
          .el-select {
            width: 80px;
            .el-input__inner {
              height: 29px;
              line-height: 29px;
              border: none;
              padding-left: 0px;
              text-align: right;
              box-sizing: border-box;
            }
          }
        }
        .subjectitem {
          margin-left: 10px;
          .el-select {
            width: 160px;
            .el-input__prefix {
              line-height: 32px;
            }
            .el-input--prefix .el-input__inner {
              padding-left: 40px;
              text-align: right;
            }
          }
        }
      }
      
      .quesbox {
        height: 400px;
        overflow: hidden;
        overflow-y: auto;
        .content_item {
          box-sizing: border-box;
          background:#fff;
          padding: 16px;
          box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.06);
          border-radius: 8px;
          margin-bottom: 10px;
          overflow-x: hidden;
          border: 1px solid #e2e2e2;
          .tit {
            font-size: 14px;
            font-weight: 700;
            margin-bottom: 10px;
            display: flex;
            justify-content: space-between;
            font-family: 'SourceHanSerifCN-Heavy';
          }
          p {
            margin: 0;
          }
          .content_top {
            font-size: 14px;
            font-weight: 400;
            color: #5c6166;
            line-height: 28px;
            img {
              max-width: 100%;
            }
          }

          .myFamily {
            font-family: '楷体';
          }
          .myFontWeight {
            font-weight: bold;
          }
          .myZhiLine {
            text-decoration: underline;
          }
          .myBoLine {
            text-decoration: underline wavy;
          }
          .myDot {
            text-emphasis: dot;
            text-emphasis-position: under;
            -webkit-text-emphasis: dot;
            -webkit-text-emphasis-position: under;
          }
          .myCenter {
            text-align: center;
          }
          .imglatex {
            height: 50px !important;
            width: auto !important;
          }
          img {
            width: 100% !important;
            height: auto !important;
          }
        }
        .nodata {
          width: 100%;
          text-align: center;
          margin-top: 50px;
          color: #8D939A;
        }
      }
    }
    .fzdialogcon {
      .checkcon {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-bottom: 10px;
      }
      .inputcon {
        display: flex;
        align-items: center;
        .name {
          width: 80px;
        }
      }
    }
    .rangedialog {
      .el-table th {
        background-color: #F8F9FA;
      }
      .el-table td {
        padding: 5px 0;
      }
      .el-table thead {
        th {
          padding: 0px;
        }
        .cell {
          line-height: 18px;
        }
      }
      .addrangebtn {
        width: 100%;
        height: 50px;
        padding: 0px;
        text-align: center;
        color: #00AA86;
        span {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .el-icon-add {
          background: url("./assets/img/add_icon1.png") no-repeat;
          background-size: 100%;
          width: .875rem;
          height: .875rem;
        }
      }
    }
  }
  .el-dialog__footer {
    border-top: 1px solid #e2e2e2;
    padding-bottom: 10px;
    .bottom_box {
      text-align: right;

      .orangebtn {
        background: #FF9900;
        border-color: #FF9900;
      }
    }
    .bottom_box1 {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  .center_box_sub_add {
    .querybox {
      .el-input--prefix .el-input__inner {
        padding-left: 45px;
      }
      .el-input__prefix {
        top: 10px;
        left: 9px;
      }
    }
    .baseFormData {
      .el-form-item {
        margin-bottom: 17px;
      }
      .el-input,
      .el-select,
      .el-date-editor {
        width: 250px !important;
      }
      // .examname {
      //   width: 250px !important;
      // }
      .form_header_box {
        .form_header_box-item {
          display: flex;
          flex-wrap: wrap;
          align-content: flex-start;

          .el-form-item {
            margin-bottom: 17px;
          }
        }
      }
      .classbox,
      .subjectbox {
        // height: 200px;
        // padding: 0px 10px 10px 10px;
        display: flex;
        flex-direction: column;

        .addcon {
          text-align: left;
          color: #00AA86;
          cursor: pointer;
          width: 80px;
        }
        .checkbox {
          text-align: left;
        }

        .class_item_box {
          display: flex;
          flex-wrap: wrap;
          align-content: flex-start;
          overflow: auto;
        }

        .class_item {
          // width: 80px;
          // height: 35px;
          padding: 6px 22px;
          text-align: center;
          border: 1px solid #DDDDDD;
          border-radius: 2px;
          color: #666666;
          margin: 5px 10px 5px 0;
          line-height: normal;
          cursor: pointer;
        }
        .class_item_selected {
          border-color: #00AA86;
          color: #00AA86;
        }
        .subjectdisabled {
          cursor: not-allowed;
        }
      }
      .subjectbox {
        // height: 100px !important;
      }
      .testmodeitem {
        .el-radio {
          margin-right: 8px;
        }
      }
    }
  }
}
.tablistpopper {
  padding: 0px !important;
  left: 270px !important;
  .tablist {
    width:452px; 
    height:auto; 
    background:#fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    border-radius: 4px;
    padding:10px;
    line-height: normal;
    .tab-head {
      display:flex;
      align-items:center;
      margin: 10px;
      justify-content: space-between;
      .head-title {
        color:#333333;
        font-size:16px;
        font-weight:bold;
        font-family: 'SourceHanSerifCN-Heavy';
      }
      .head-btn {
        color:#00AA86;
        font-size:14px;
        cursor: pointer;
        text-decoration: unset;
        display: flex;
        align-items: center;
        img {
          width: 14px;
          height: 12px;
        }
      }
    }
    .list-box { 
      display:flex;
      flex-wrap: wrap;
      .list-item {
        margin:10px;
        display:flex;
        flex-direction:column;
        align-items:center;
        justify-content:center;
        cursor: pointer;
        text-decoration: unset;
        img {
          width:88px;
          height:88px;
        }
        .list-title {
          color:#666666;
          font-size:14px;
          margin-top:10px;
        }
      }
    }
  }
  .popper__arrow {
    left: 105px !important;
  }
}

.newtablistpopper {
  padding: 0px !important;
  left: 295px !important;
  width: auto !important;
}
.newtablistpopper .popper__arrow {
  left: 55px !important;
}
.newtablistpopper .tablist {
  width:510px; 
  height:auto; 
  background:#fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  border-radius: 4px;
  padding:10px;
  line-height: normal;
}
.newtablistpopper .tablist .el-divider--horizontal {
  margin: 20px 0;
}
.newtablistpopper .tablist .tab-head {
  display:flex;
  align-items:center;
  margin: 10px;
  justify-content: space-between;
}
.newtablistpopper .tablist .tab-head .head-title {
  color:#000000;
  font-size:18px;
  font-weight:bold;
  font-family: 'SourceHanSerifCN-Heavy';
}
.newtablistpopper .tablist .tab-head .el-button {
  padding: 8px 15px;
}
.newtablistpopper .tablist .tab-head .head-btn {
  color:#00AA86;
  font-size:14px;
  cursor: pointer;
  text-decoration: unset;
  display: flex;
  align-items: center;
}
.newtablistpopper .tablist .tab-head .head-btn img {
  width: 14px;
  height: 12px;
}
.newtablistpopper .tablist .list-box {
  height: 350px;
  overflow: hidden;
  overflow-y: auto;
  padding-left: 14px;
}
.newtablistpopper .tablist .list-box .box-item {
  margin-bottom: 14px;
}
.newtablistpopper .tablist .list-box .box-item .item-title {
  display: flex;
  align-items: center;
  color: #000000;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  font-family: 'SourceHanSerifCN-Heavy';
}
.newtablistpopper .tablist .list-box .box-item .item-title .verticalbar {
  background: #01AA86;
  width: 2px;
  height: 12px;
  border-radius: 1.28px  1.28px  1.28px  1.28px;
  margin-right: 4px;
}
.newtablistpopper .tablist .list-box .box-item .tab-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.newtablistpopper .tablist .list-box .box-item .tab-list .tab-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 90px;
  height: 100px;
  cursor: pointer;
}
.newtablistpopper .tablist .list-box .box-item .tab-list .tab-item-active {
  background: #E5F7F3;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #01AA86;
}
.newtablistpopper .tablist .list-box .box-item .tab-list .tab-item img {
  width: 56px;
  height: 56px;
  margin-bottom: 6px;
}
.newtablistpopper .tablist .list-box .box-item .tab-list .tab-item span {
  color: #303030;
}
</style>
